const SESSION_KEY = "fowebPortalUser";

export function readPortalSession() {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed._id) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function savePortalSession(user) {
  if (!user || !user._id) {
    localStorage.removeItem(SESSION_KEY);
    return;
  }
  const safe = {
    _id: user._id,
    name: user.name || "",
    url: user.url || "",
    remarks: user.remarks || "",
    createdObjectCount: Array.isArray(user.createdObjectCount) ? user.createdObjectCount : [],
    approvedObjectCount: Array.isArray(user.approvedObjectCount) ? user.approvedObjectCount : [],
  };
  localStorage.setItem(SESSION_KEY, JSON.stringify(safe));
}

export function clearPortalSession() {
  localStorage.removeItem(SESSION_KEY);
}
